import type { TranslationDictionary } from "./types";

export const EN_DICTIONARY: TranslationDictionary = {
    "app.newTask": "New",
    "app.newTaskFull": "New task",
    "app.newTaskAria": "New chat",
    "sidebar.searchPlaceholder": "Search prompts or task ID",
    "sidebar.taskCenter": "Task center",
    "sidebar.openTaskCenter": "Open task center",
    "sidebar.closeTaskCenter": "Close task center",
    "sidebar.filters": "Task filters",
    "sidebar.allRatios": "All ratios",
    "sidebar.allOrientations": "All orientations",
    "sidebar.allModes": "All modes",
    "sidebar.allResolutions": "All resolutions",
    "sidebar.activeTasks": "Active tasks",
    "sidebar.topAnchors": "Top time navigation",
    "sidebar.bottomAnchors": "Bottom time navigation",
    "sidebar.resize": "Resize sidebar",
    "workspace.title": "AI Innovation Studio",
    "workspace.newImage": "New image",
    "workspace.ariaLabel": "AI Innovation Studio, new image",
    "batch.selected": "0 selected",
    "batch.selectedCount": "{count} selected",
    "batch.archivedCount": "Archived {count} chats",
    "batch.archiveFailed": "Batch archive failed",
    "batch.runningCannotDeleteSelected": "Selected chats are running and cannot be deleted",
    "batch.deleteTitle": "Delete {count} chats?",
    "batch.deleteMessage": "This will also delete local image files.",
    "batch.deleteSkippedDetail": "{count} running tasks will be kept",
    "batch.deleteSkippedSuffix": ", {count} running tasks not deleted",
    "batch.deletedCount": "Deleted {count} chats{skipped}",
    "batch.deleteFailed": "Batch delete failed",
    "action.archive": "Archive",
    "action.delete": "Delete",
    "action.cancel": "Cancel",
    "action.edit": "Edit",
    "action.clear": "Clear",
    "action.paste": "Paste",
    "action.find": "Find",
    "action.replace": "Replace",
    "action.close": "Close",
    "action.confirm": "Confirm",
    "action.confirmQuestion": "Confirm action?",
    "action.refresh": "Refresh",
    "action.save": "Save",
    "action.add": "Add",
    "action.new": "New",
    "action.import": "Import",
    "action.export": "Export",
    "queue.empty": "No queue",
    "queue.emptyAria": "Queue status: no queued tasks",
    "queue.jumpTitle": "Jump to active tasks",
    "queue.emptyTitle": "No queued tasks",
    "queue.channel": "Channels {count}",
    "queue.availableChannels": "Available channels {usable}/{total}",
    "queue.dispatching": "Scheduling · waiting {waiting}",
    "queue.runningWaiting": "Running {running} · waiting {waiting}",
    "queue.statusLabel": "Queue status: {text} · {channelText}. Click to jump to active tasks",
    "queue.runningActions": "Running task queue actions",
    "queue.waitingActions": "Waiting task queue actions",
    "queue.cancelRunning": "Cancel",
    "queue.cancelRunningTitle": "Cancel running task",
    "queue.dragWaiting": "Drag to reorder waiting task",
    "queue.dragSort": "Drag to sort",
    "queue.moveUp": "Up",
    "queue.moveUpTitle": "Move waiting task up",
    "queue.moveDown": "Down",
    "queue.moveDownTitle": "Move waiting task down",
    "queue.promote": "Top",
    "queue.promoteTitle": "Move waiting task to top",
    "queue.promoteFailed": "Move to top failed",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Delete waiting task",
    "queue.deleteWaitingTitleConfirm": "Delete waiting task?",
    "queue.deleteWaitingMessage": "This removes it from the queue and history list.",
    "queue.deleteQueuedFailed": "Failed to delete queued task",
    "queue.queuedDeleted": "Queued task deleted",
    "queue.cancelRunningConfirm": "Cancel task",
    "queue.cancelRunningTitleConfirm": "Cancel running task?",
    "queue.cancelRunningMessage": "The current task will stop. History will be kept.",
    "queue.cancelRunningFailed": "Failed to cancel task",
    "queue.runningCancelled": "Task cancelled",
    "queue.reorderFailed": "Failed to reorder queue",
    "queue.realtimeUpdateFailed": "Failed to update live status",
    "queue.realtimeDisconnected": "Live status connection was lost. Refresh the page to recover.",
    "queue.readFailed": "Failed to load queue",
    "status.waiting": "Waiting",
    "status.shownActiveTasks": "Showing active tasks",
    "status.jsonCopied": "JSON copied",
    "taskStatus.submitting": "Submitting",
    "taskStatus.running": "Generating",
    "taskStatus.runningWithElapsed": "Generating · {elapsed}",
    "taskStatus.completed": "Completed",
    "taskStatus.partialFailed": "Partially failed",
    "taskStatus.failed": "Failed",
    "taskStatus.queued": "Queued",
    "taskStatus.unknown": "Unknown status",
    "taskStatus.task": "Task",
    "taskStatus.connectionInterrupted": "Connection interrupted",
    "taskStatus.lastFailed": "Last failed",
    "taskStatus.waitingRetry": "{reason}, waiting to retry (attempt {attempt}/{max})",
    "taskStatus.retrying": "{reason}, retrying (attempt {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Attempt {attempt}/{max}, not retryable",
    "taskStatus.manualRetryAvailable": "Stopped; failed images can be retried manually",
    "taskStatus.waitingRetryShort": "Waiting retry",
    "taskStatus.retryingShort": "Retrying",
    "taskStatus.nonRetryableShort": "Not retryable",
    "taskStatus.manualRetryShort": "Manual retry",
    "taskStatus.stoppedShort": "Stopped",
    "taskStatus.runtime": "Duration {duration}",
    "taskStatus.runtimeCompleted": "Duration {duration} · completed {time}",
    "taskStatus.completedAt": "Completed {time}",
    "taskCard.count": "{count} images",
    "taskCard.successCount": "succeeded {count}",
    "taskCard.failedCount": "failed {count}",
    "taskCard.runningCount": "generating {count}",
    "taskCard.waitingCount": "waiting {count}",
    "taskCard.textToImageThumb": "Text-to-image task thumbnail",
    "taskCard.imageToImageThumb": "Image-to-image task thumbnail",
    "taskCard.failedThumb": "Task failed",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Edit",
    "taskMode.generate": "Generate",
    "document.generatingQueue": "Generating · queue {total}",
    "document.queuedWaiting": "Queued · waiting {count}",
    "runFeedback.editing": "Editing",
    "runFeedback.generating": "Generating",
    "runFeedback.status": "{action}, elapsed {elapsed}",
    "footer.archive": "Archive",
    "footer.archiveCount": "Archive {count}",
    "footer.historyLibrary": "History",
    "historyLibrary.openFull": "Open full history library",
    "history.documentTitle": "History - 阿泰生图",
    "history.back": "Back to generator",
    "history.title": "History",
    "history.loading": "Loading",
    "history.total": "{total} tasks · {archived} archived",
    "history.search": "Search",
    "history.searchPlaceholder": "Search prompts or task ID",
    "history.clear": "Clear",
    "history.type": "Type",
    "history.allTypes": "All types",
    "history.type.textToImage": "Text to image",
    "history.type.imageToImage": "Image to image",
    "history.month": "Month",
    "history.status": "Status",
    "history.promptMode": "Prompt handling",
    "history.size": "Size",
    "history.quality": "Quality",
    "history.ratio": "Ratio",
    "history.orientation": "Orientation",
    "history.backend": "Backend",
    "history.provider": "Provider",
    "history.archived": "Archived",
    "history.all": "All",
    "history.allMonths": "All months",
    "history.allStatuses": "All statuses",
    "history.allPromptModes": "All modes",
    "history.allSizes": "All sizes",
    "history.allQualities": "All qualities",
    "history.allRatios": "All ratios",
    "history.ratioOther": "Other",
    "history.allOrientations": "All orientations",
    "history.allBackends": "All backends",
    "history.allProviders": "All providers",
    "history.unarchived": "Unarchived",
    "history.archivedOnly": "Archived",
    "history.tasksAria": "Historical tasks",
    "history.taskListTitle": "Historical tasks",
    "history.browseNewest": "Browse newest first",
    "history.view": "View",
    "history.grid": "Grid",
    "history.list": "List",
    "history.sort": "Sort",
    "history.newest": "Newest first",
    "history.oldest": "Oldest first",
    "history.refresh": "Refresh",
    "history.selectedCount": "{count} tasks selected",
    "history.confirmDelete": "Confirm delete",
    "history.detail": "Task detail",
    "history.detailTitle": "History task",
    "history.closeDetail": "Close task detail",
    "history.resizeFilters": "Resize filter sidebar",
    "history.resizeDetail": "Resize detail pane",
    "history.detailEmpty": "Select a historical task to view details",
    "history.loadingDetail": "Loading detail...",
    "history.loadMore": "Load more",
    "history.loadingMore": "Loading...",
    "history.noMore": "No more tasks",
    "history.loadFailed": "Load failed. Refresh or keep scrolling to retry",
    "history.summaryFailed": "Failed to load summary",
    "history.tasksFailed": "Failed to load tasks",
    "history.detailFailed": "Failed to load detail",
    "history.noMatches": "No matching tasks",
    "history.loadedCount": "{count} loaded",
    "history.windowNotice": "The mounted list is limited to {count} tasks; scroll up or down to restore adjacent tasks on demand.",
    "history.selectTask": "Select task",
    "history.viewing": "Viewing",
    "history.noPreview": "No preview images",
    "history.downloadAll": "Download ZIP",
    "history.downloadImage": "Download image",
    "history.downloadSelected": "Download selected",
    "history.deleteUnselected": "Delete unselected",
    "history.confirmDeleteUnselected": "Confirm delete unselected",
    "history.selected": "Selected",
    "history.select": "Select",
    "history.downloadIndex": "Download {index}",
    "history.addReference": "Add reference",
    "history.outputActions": "Result image actions",
    "history.inputReferences": "Input references",
    "history.inputReferenceIndex": "Input reference {index}",
    "history.copyPrompt": "Copy prompt",
    "history.copyPrompts": "Copy prompts",
    "history.copyPromptShort": "Copy",
    "history.copyPromptPanel": "Copy {title}",
    "history.copyOutputPromptPanel": "Copy image {index} revised prompt",
    "history.copyTaskIds": "Copy task IDs",
    "history.reuseTask": "View in generator",
    "history.downloadTask": "Download",
    "history.downloadSelectedTasks": "Batch download",
    "history.contextMenuLabel": "History task context menu",
    "history.promptCopied": "Prompt copied",
    "history.promptsCopied": "Copied prompts from {count} tasks",
    "history.taskIdsCopied": "Copied {count} task IDs",
    "history.promptCopiedShort": "Copied",
    "history.promptCopyFailed": "Failed to copy prompt",
    "history.promptCopyFailedShort": "Failed",
    "history.noPrompt": "This task has no prompt to copy",
    "history.noPromptShort": "Empty",
    "history.downloadStarted": "Download started",
    "history.batchDownloadStarted": "Started downloads for {count} tasks",
    "history.noDownloadableOutputs": "No downloadable images",
    "history.confirmDeleteSelected": "Confirm selected delete",
    "history.openPreview": "Open preview",
    "history.closePreview": "Close preview",
    "history.untitled": "Untitled",
    "history.promptCompare": "Prompt comparison",
    "history.promptOriginal": "Original prompt",
    "history.promptSubmitted": "Optimized prompt",
    "history.promptRevised": "Revised result",
    "history.outputRevisedPromptTitle": "Image {index} revised prompt",
    "history.outputRevisedPromptNotice": "Each image has its own revised prompt below the image.",
    "history.promptEmpty": "No content",
    "history.promptMode.strict": "Faithful",
    "history.promptMode.original": "Original",
    "history.promptMode.off": "Automatic",
    "history.quality.high": "High",
    "history.quality.medium": "Medium",
    "history.quality.low": "Low",
    "history.quality.auto": "Auto",
    "footer.batch": "Batch",
    "footer.storage": "Storage",
    "footer.apiStatus": "API status: OK",
    "footer.version": "Version {version}",
    "footer.versionInfo": "Version info",
    "footer.versionLoading": "Version ...",
    "footer.updateBadge": "New version available",
    "footer.updateAvailable": "New version {version}",
    "version.title": "Version & Update",
    "version.loading": "Reading version status",
    "version.current": "Current version",
    "version.latest": "Latest version",
    "version.source": "Runtime",
    "version.sourcePortable": "Portable package",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "Source checkout",
    "version.upToDate": "You are already on the latest version",
    "version.updateAvailable": "Version {version} is available. Close the WebUI server window, then run the updater to upgrade.",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "This runtime is not a portable package, so the updater cannot be started automatically.",
    "version.openUpdater": "Start updater",
    "version.release": "View release",
    "version.updaterStarted": "Updater started. Close the current WebUI server window, then follow the updater prompts.",
    "version.updaterFailed": "Could not start the updater. Run the updater script from the package manually.",
    "version.onboardingTitle": "0.5.5 adds standard app packages",
    "version.onboardingStatus": "You have upgraded to {version}. You can keep using the portable package or switch to the standard app package.",
    "version.onboardingBody": "This release adds macOS DMG and Windows App ZIP packages. New users should use the standard package; the current portable package still works.",
    "version.onboardingDataPortable": "Your current data remains in this portable package's data/ folder.",
    "version.onboardingStandardData": "The standard app stores data in the system app data directory: macOS Application Support / Windows %APPDATA%.",
    "version.onboardingMigration": "When switching to the standard app, use the migration assistant to copy old data. It will not move or overwrite the original data.",
    "version.standardDownload": "Download standard app",
    "version.continuePortable": "Keep using portable",
    "version.dismissOnboarding": "Don't show again",
    "version.dismissFailed": "Could not save this notice state. Try again later.",
    "version.historyTitle": "What's new",
    "version.historyEmpty": "No release notes available",
    "version.currentBadge": "Current",
    "version.releaseDate": "{date}",
        "version.change.radio_group_delegation_fix": "Fix resolution and quantity selection buttons with universal event delegation.",
    "version.change.top_nav_overlap_fix": "Fix header title and user badge overlapping on compact viewports.",
    "version.change.user_management_form_responsive_fix": "Responsive layout for employee creation form to avoid text truncation.",
    "version.change.generation_stats_realtime_sync": "Realtime synchronization of generation tasks into analytics dashboard.",
    "version.change.clean_mock_users": "Clean up mock user accounts to ensure pristine database state.",
    "version.change.strict_history_privacy_guard": "Strict privacy lockdown preventing unauthenticated history inspection.",
    "version.change.enforce_login_guard": "Mandatory login enforcement for generation and internal assets.",
    "version.change.task_user_privacy_filter": "Strict task privacy filter isolating data between team members.",
                                    "version.change.revert_cluttered_portal_keep_clean_studio": "Revert cluttered experimental portal view to maintain clean, focused, professional studio workspace.",
    "version.change.realtime_auto_reconnect_resilience": "Implement silent exponential backoff auto-reconnection for EventSource, eliminating false 'realtime disconnected' alarms.",
    "version.change.smooth_preview_transition_on_completion": "Smooth preview loading transition after task completion with clear rendering cues.",
    "version.change.prompt_optimizer_dom_fix": "Fix prompt optimizer text sync to properly update rich prompt editor, character counts and preview.",
    "version.change.prompt_actions_compact_layout": "Streamline prompt action buttons without bulky icons and symbols, ensuring compact single-line fit.",
    "version.change.deepseek_prompt_optimizer": "Added DeepSeek-v4-Flash powered 'Optimize Prompt' assistant to enrich details, lighting, and textures with one-click adoption.",
    "version.change.auto_enable_brand_material_on_confirm": "Auto-enable selected brand material layer upon confirmation so state turns to 'On' seamlessly.",
    "version.change.graceful_network_json_fallback": "Gracefully handle network hiccups and 502 HTML error pages to avoid raw JSON parse errors.",
    "version.change.task_completion_realtime_render_fix": "Fix task preview stuck in running feedback and immediately render all generated images.",
    "version.change.sidebar_card_thumbnail_include_fix": "Synchronize full output images and thumbnails onto sidebar cards instantly.",
    "version.change.built_in_enterprise_prompt_templates": "Built-in 50 production-grade enterprise prompt templates across 6 major professional business categories.",
    "version.change.server_system_metrics": "System telemetry metrics monitoring CPU, Memory, and Disk usage.",
    "version.change.cleanup_history_images": "History image cleanup utility supporting 1/7/30 days and custom date ranges.",
    "version.change.enterprise_auth_system": "Enterprise user system with multi-role authentication (Admin & Employee)",
    "version.change.user_privacy_isolation": "Strict user privacy isolation for tasks and generation artifacts",
    "version.change.analytics_dashboard": "Analytics dashboard for team enterprise statistics and individual reports",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "Expanded the official Logo, Slogan, and business signature library with additional brands, business lines, horizontal and vertical layouts, and inverted variants.",
    "version.change.material_picker_modal": "Material picker is now a dialog with large thumbnails, categories, search, and multi-select.",
    "version.change.brand_name": "Renamed the product to AI Innovation Studio across all languages.",
    "version.change.brand_templates": "Added selectable brand templates and automatic composition for logos, slogans, and other brand elements.",
    "version.change.brand_preview": "Branded results now stay consistent across previews, history, zoom, and downloads, while the original image remains available.",
    "version.change.mobile_workspace": "Compressed the mobile header, action bar, material summary, and empty preview to expose more of the creation flow.",
    "version.change.task_center": "Condensed the mobile task center and added a badge for running and waiting tasks.",
    "version.change.brand_launch": "Launched the branded mobile experience with Hengtai visual assets.",
    "version.change.core_workflow": "Delivered the core generation, task queue, history, gallery, and settings workflow.",
    "notifications.title": "Notifications",
    "notifications.unread": "Notifications, {count} unread",
    "notifications.unreadSummary": "{count} unread",
    "notifications.empty": "No task notifications",
    "notifications.taskFailed": "Task failed",
    "notifications.taskPartial": "Task partially completed",
    "notifications.taskCompleted": "Task completed",
    "notifications.generationFailed": "Generation failed",
    "notifications.successCount": "{count} succeeded",
    "notifications.resultAvailable": "Results available",
    "notifications.failedCount": "{count} failed",
    "notifications.systemUnsupported": "This browser does not support system notifications",
    "notifications.systemBlocked": "System notifications are blocked by the browser. Enable them in browser settings.",
    "notifications.systemDenied": "System notifications are not enabled",
    "notifications.systemEnabled": "System notifications enabled",
    "notifications.taskMissing": "Task does not exist or was deleted",
    "theme.label": "Theme",
    "theme.system": "Auto",
    "theme.light": "Light",
    "theme.dark": "Dark",
    "language.label": "Interface language",
    "language.zh": "中",
    "language.zhCN": "Simplified Chinese",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Auth source",
    "auth.checking": "Checking auth",
    "auth.missingCodexSession": "No Codex session detected",
    "auth.switchFailed": "Failed to switch auth source",
    "auth.sourceUnavailable": "{source} unavailable",
    "auth.notActive": "Not active",
    "api.settings": "System Settings",
    "api.provider": "API provider",
    "imageInput.title": "Images",
    "imageInput.uploadAria": "Click, drop, or paste images and files",
    "imageInput.uploadFull": "Click, drop, or paste images and files",
    "imageInput.uploadCompact": "Add input",
    "imageInput.uploadSubtitle": "Supports images and Responses reference files",
    "imageInput.recent": "Recent uploads",
    "imageInput.recentBadge": "Recent",
    "imageInput.uploadBadge": "Upload",
    "imageInput.addToGallery": "Add to gallery",
    "imageInput.addToGalleryShort": "Gallery",
    "imageInput.removeImage": "Remove image",
    "imageInput.editedBadge": "Edited",
    "imageInput.editImage": "Edit {name}",
    "imageInput.deletedRecent": "Recent upload deleted",
    "imageInput.deletedGallery": "Gallery image deleted",
    "recentAssets.defaultName": "Recent upload",
    "recentAssets.use": "Use {name}",
    "recentAssets.delete": "Delete {name}",
    "recentAssets.deleteTitle": "Delete recent upload?",
    "recentAssets.deleteMessage": "This will remove the image from Recent uploads. If it is currently selected as an image input, it will be removed from the current input. Historical tasks that reference this recent upload will lose that input preview. The public gallery is not affected.",
    "recentAssets.loadFailed": "Failed to load recent uploads",
    "recentAssets.deleteFailed": "Failed to delete recent upload",
    "recentAssets.deleted": "Recent upload deleted",
    "inputSource.uploadFallback": "Uploaded image",
    "inputSource.galleryFallback": "Gallery image",
    "inputSource.focusPasteFallback": "{prefix}. Image input is focused; press {shortcut} to paste images.",
    "inputSource.pastedCount": "Pasted {count} clipboard images",
    "inputSource.droppedCount": "Added {count} dropped images",
    "inputSource.dropImagesOnly": "Drop image files only",
    "inputSource.clipboardUnsupported": "This browser cannot read the clipboard directly",
    "inputSource.clipboardEmpty": "No clipboard images found",
    "inputSource.clipboardDenied": "The browser blocked direct clipboard access",
    "inputSource.clipboardReadFailed": "Failed to read the clipboard",
    "status.missingGalleryReference": "A gallery reference image has been deleted. Remove it before generating.",
    "status.missingRecentReference": "A recent upload reference image has been deleted. Remove it before generating.",
    "status.emptyPrompt": "Enter a prompt",
    "status.editNeedsImage": "Edit mode requires at least one image",
    "status.loadedTask": "Loaded task {taskId}",
    "status.reusedTask": "Opened task {taskId} in generator",
    "status.loadingHistoryInputs": "Loading historical input images...",
    "status.historyInputLoadFailed": "Failed to load historical input image: {url}",
    "referenceCollector.alreadyStaged": "Already staged as a reference",
    "referenceCollector.staged": "Staged {count} reference images",
    "referenceCollector.title": "Pending references · {count}",
    "referenceCollector.addAll": "Add all references",
    "referenceCollector.itemFallback": "Pending reference",
    "referenceCollector.remove": "Remove pending reference",
    "referenceCollector.cleared": "Pending references cleared",
    "referenceCollector.added": "Added {count} reference images",
    "referenceCollector.addFailed": "Failed to add pending references",
    "referenceCollector.readFailed": "Failed to read image: {status}",
    "gallery.quick": "Quick gallery",
    "gallery.current": "Current category gallery",
    "gallery.categories": "Gallery categories",
    "gallery.categoryPortrait": "Portrait",
    "gallery.categoryCharacter": "Character",
    "gallery.categoryProduct": "Product",
    "gallery.categoryPortraitRole": "Portrait reference",
    "gallery.categoryCharacterRole": "Character reference",
    "gallery.categoryProductRole": "Product reference",
    "gallery.referenceRole": "Reference image",
    "gallery.manage": "Manage gallery",
    "gallery.loadFailed": "Failed to load gallery",
    "gallery.imageOrderUpdateFailed": "Failed to update image order",
    "gallery.imageOrderUpdated": "Image order updated",
    "gallery.categoryName": "Category name",
    "gallery.categoryPromptRole": "Prompt role",
    "gallery.categorySave": "Save",
    "gallery.categoryDelete": "Delete",
    "gallery.categoryLoadFailed": "Failed to load categories",
    "gallery.categoryNameRequired": "Enter a category name",
    "gallery.categoryCreateFailed": "Failed to add category",
    "gallery.categoryCreated": "Category added",
    "gallery.categorySaveFailed": "Failed to save category",
    "gallery.categorySaved": "Category saved",
    "gallery.categoryDeleteTitle": "Delete gallery category?",
    "gallery.categoryDeleteMessage": "Images in this category will move to another category. Gallery images will not be deleted.",
    "gallery.categoryDeleteConfirm": "Delete category",
    "gallery.categoryDeleteFailed": "Failed to delete category",
    "gallery.categoryDeletedMigrated": "Category \"{name}\" deleted and images migrated",
    "gallery.categoryOrderUpdateFailed": "Failed to update category order",
    "gallery.categoryOrderUpdated": "Category order updated",
    "gallery.categoryFallback": "Gallery category",
    "gallery.imageFallback": "Gallery image",
    "gallery.imageLoadFailed": "Failed to load this image",
    "gallery.editImageLoadFailed": "Failed to load this image for editing",
    "gallery.cannotAddImage": "This image cannot be added to the gallery",
    "gallery.nameRequired": "Enter a gallery name",
    "gallery.saveFailed": "Failed to save gallery image",
    "gallery.savedAsReference": "Added to gallery and switched to gallery reference",
    "gallery.renameImage": "Rename gallery image",
    "gallery.moveToCategory": "Move to category",
    "gallery.categoryRequired": "Choose a gallery category",
    "gallery.promptNoteTitle": "Gallery reference note",
    "gallery.updateFailed": "Failed to update gallery",
    "gallery.selectImageFile": "Choose an image file",
    "gallery.replaceImageFailed": "Failed to replace gallery image",
    "gallery.replacedImage": "Replaced the source image for \"{name}\"",
    "gallery.deleteImageTitle": "Delete gallery image?",
    "gallery.deleteImageMessage": "Historical task references will show as deleted.",
    "gallery.deleteFailed": "Failed to delete gallery image",
    "gallery.deletedSuffix": " (deleted)",
    "gallery.editImageLabel": "Edit gallery image",
    "gallery.fieldCategory": "Category",
    "gallery.fieldPromptNote": "Reference note",
    "gallery.fieldName": "Name",
    "quickGallery.empty": "No {category} images",
    "quickGallery.searchPlaceholder": "Search images",
    "quickGallery.noResults": "No matching images",
    "quickGallery.open": "Pick from gallery",
    "quickGallery.openTitle": "Pick from gallery",
    "quickGallery.title": "Pick images",
    "quickGallery.subtitle": "Click to add to the input area, click to remove",
    "quickGallery.close": "Close image picker",
    "quickGallery.done": "Done",
    "quickGallery.tabGallery": "Public Gallery",
    "quickGallery.tabBrand": "Brand Assets",
    "quickGallery.brandSummaryHint": "Configure logo and business signature",
    "promptGallery.remove": "Remove @{name}",
    "prompt.title": "Prompt",
    "prompt.editorLabel": "Prompt",
    "prompt.placeholder": "Describe the image you want to generate or edit. Type @ for gallery references, # for color codes, and ~ for prompt snippets.",
    "prompt.run": "Generate",
    "prompt.runEdit": "Start editing",
    "prompt.runTitle": "Generate (Cmd+Enter)",
    "prompt.runEditTitle": "Start editing (Cmd+Enter)",
    "prompt.findPanel": "Find and replace prompt",
    "prompt.findText": "Find text",
    "prompt.replaceWith": "Replace with",
    "prompt.findActions": "Find and replace actions",
    "prompt.countZero": "0 matches",
    "prompt.matchCount": "{count} matches",
    "prompt.foundCount": "Found {count} matches",
    "prompt.noMatch": "No matching text",
    "prompt.replacedCount": "Replaced {count} matches",
    "prompt.closeFind": "Close find and replace",
    "prompt.recentTemplates": "Recent templates",
    "prompt.manageTemplates": "Manage templates",
    "promptModel.galleryHeader": "Reference image notes:",
    "promptModel.galleryInstruction": "- Reference image {number}: gallery \"{name}\", role: {role}. @{name} in the prompt refers to this image.{note}",
    "outputSettings.title": "Output",
    "output.lock.lock": "Lock parameters",
    "output.lock.unlock": "Unlock and edit",
    "output.lock.current": "Current lock",
    "output.lock.task": "Selected task parameters",
    "output.lock.adoptTask": "Use these task parameters",
    "output.lock.frame": "Frame",
    "output.lock.outputCount": "Output count",
    "output.lock.output": "Output",
"output.lock.search": "Search",
    "output.lock.call": "Call",
    "output.lock.sheets": "images",
    "output.lock.imageModel": "Image model",
    "output.lock.prompt": "Prompt",
    "output.lock.fileFormat": "File format",
    "output.lock.taskHint": "Viewing the selected task only; your locked parameters stay unchanged. Using them does not change the system channel.",
    "output.lock.lockedHint": "Parameters are fixed. Use the lock icon at the top right to edit.",
    "output.lock.enabled": "On",
    "output.lock.disabled": "Off",
    "output.mainModel": "Main model",
    "output.selectMainModel": "Select main model",
    "output.mainModelCustomForInput": "Use a custom model for the current input",
    "output.apiDirect": "API Direct",
    "output.apiToolModel": "Using API image generation model",
    "output.mainModelUnused": "Main model is not used for this request",
    "output.webSearch": "Web search",
    "output.webSearchToggle": "On",
    "output.webSearchTitle": "Search the web first, then use it for this generation; Codex and API Responses only",
    "output.promptMode": "Prompt handling",
    "output.modeOriginal": "Original",
    "output.modeStrict": "Faithful",
    "output.modeCreative": "Automatic",
    "output.promptHelp": "Explain prompt handling",
    "output.promptHelpTitle": "Prompt handling",
    "output.promptHelp.responsesChannel": "Responses · main model involved",
    "output.promptHelp.imagesChannel": "Images · direct generation",
    "output.promptHelp.responses.original": "Sends your original text to the main model and asks the image tool to preserve it; the main model may still produce a revised prompt.",
    "output.promptHelp.responses.strict": "Lets the main model organize or expand the prompt, while preserving hard constraints such as subjects, text, colors, and composition.",
    "output.promptHelp.responses.automatic": "Adds no extra constraints, allowing the main model to interpret and optimize the prompt before calling the image tool.",
    "output.promptHelp.images.original": "Adds no app-level prompt rules and submits your original text directly to the image endpoint.",
    "output.promptHelp.images.strict": "Submits fidelity rules together with the original prompt to emphasize every hard constraint.",
    "output.promptHelp.images.automatic": "Uses the image endpoint's default handling; required gallery-reference notes are still included.",
    "output.sizeMode": "Size mode",
    "output.sizePreset": "Preset",
    "output.sizeCustom": "Custom",
    "output.orientation": "Orientation",
    "output.square": "Square",
    "output.portrait": "Portrait",
    "output.landscape": "Landscape",
    "output.resolution": "Resolution",
    "output.pixelSize": "Pixel size",
    "output.width": "Width",
    "output.height": "Height",
    "output.swapSize": "Swap width and height",
    "output.customSizeHint": "Unit px · 16-3840 · multiple of 16 · ≤3:1",
    "output.imageSizeUnavailable": "Image size unavailable",
    "output.imageLoadFailed": "Image failed to load",
    "output.customSizeRequired": "Enter width and height",
    "output.customSizeBounds": "Width and height must be 16-3840 px",
    "output.customSizeMultiple": "Width and height must be multiples of 16",
    "output.customSizeRatio": "Long-to-short side ratio cannot exceed 3:1",
    "output.customSizePixels": "Total pixels must be 655,360-8,294,400",
    "output.ratioLock": "Ratio lock (optional)",
    "output.customRatio": "Custom aspect ratio",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Use the first reference image aspect ratio",
    "output.useFirstImage": "From image",
    "output.ratioHint": "Leave blank for free size · Fill both to sync",
    "output.ratio": "Ratio",
    "output.quality": "Quality",
    "output.qualityAuto": "Auto",
    "output.qualityLow": "Low",
    "output.qualityMedium": "Medium",
    "output.qualityHigh": "High",
    "output.quantity": "Count",
    "output.pixelPreview": "Output pixels: 1024 x 1024 px",
    "output.pixelPreviewValue": "Output pixels: {value}",
    "output.pixelPreviewAuto": "Output pixels: auto (OpenAI chooses automatically)",
    "output.format": "Format",
    "output.compression": "Compression",
    "output.moderation": "Moderation",
    "preview.title": "Preview",
    "preview.selectedZero": "0 selected",
    "preview.selectedCount": "Selected {selected}/{total}",
    "preview.downloadSelected": "Download selected",
    "preview.deleteUnselected": "Delete unselected",
    "preview.downloadAll": "Download ZIP",
    "preview.empty": "No images yet",
    "preview.taskFailed": "Task failed",
    "preview.partialFailed": "Some images failed",
    "preview.failedOutput": "Image {index} failed",
    "preview.progressLine": "Completed {generated} / {total} · elapsed {elapsed}",
    "preview.failureLine": "Completed {generated} / {total} · failed {failed}",
    "preview.elapsedLine": "Elapsed {elapsed}",
    "preview.lastError": "Last error: {error}",
    "preview.continueGenerating": "Continuing generation",
    "preview.waitingContinue": "Waiting to continue",
    "preview.retryFailed": "Retry failed images",
    "preview.acceptSuccesses": "Accept successful results",
    "preview.generateMode": "Generation",
    "preview.editMode": "Edit",
    "preview.runningTitle": "{mode} running",
    "preview.submittingTitle": "Submitting task",
    "preview.queuedTitle": "Task queued",
    "preview.submittingDetail": "Saving inputs and adding the task to the queue. Generation will start automatically.",
    "preview.queuedDetail": "The task is in the queue and waiting for an available channel.",
    "preview.featured": "Selected",
    "preview.addFeatured": "Select result",
    "preview.selectedFeatured": "Selected",
    "preview.removeFeatured": "Deselect result",
    "preview.selectionAdded": "Result selected",
    "preview.selectionRemoved": "Result deselected",
    "preview.selectionUpdateFailed": "Failed to update selection",
    "preview.noUnselectedOutputs": "No unselected images to delete",
    "preview.deleteUnselectedTitle": "Delete unselected images?",
    "preview.deleteUnselectedMessage": "This will delete local image files for unselected results in this task.",
    "preview.deleteUnselectedDetail": "Keep {selected}, delete {deleted}",
    "preview.deleteUnselectedFailed": "Failed to delete unselected images",
    "preview.deleteUnselectedDone": "Unselected images deleted",
    "preview.addReference": "Add reference",
    "preview.stage": "Stage",
    "preview.stageReference": "Stage as pending reference",
    "preview.prompt": "Prompt",
    "preview.download": "Download",
    "preview.downloadImage": "Download this image",
    "brand.branded": "Branded",
    "brand.raw": "Original",
    "brand.downloadBranded": "Download branded",
    "brand.processing": "Branding…",
    "brand.failed": "Branding failed",
    "brand.recompose": "Re-composite",
    "brand.recomposing": "Compositing…",
    "brand.materialsTitle": "Brand assets",
    "brand.materialsHint": "Applied after generation without AI redrawing",
    "brand.materialsChoose": "Choose a brand package",
    "brand.layers": "Brand asset layers",
    "brand.logoLayer": "Logo",
    "brand.sloganLayer": "Slogan and business signature",
    "brand.sloganMaterialName": "Brand slogan and business signature",
    "brand.logoHint": "Choose the logo overlay to apply after generation",
    "brand.sloganHint": "Choose the slogan and business signature overlay to apply after generation",
    "brand.enabled": "On",
    "brand.disabled": "Off",
    "brand.notSelected": "Not selected",
    "brand.materialsNone": "None",
    "brand.viewAll": "View all kits",
    "brand.drawerTitle": "Brand assets",
    "brand.drawerSummary": "Choose one brand kit to apply after generation",
    "brand.search": "Search brand kits",
    "brand.filter": "Brand asset filter",
    "brand.all": "All",
    "brand.empty": "No matching brand kits",
    "brand.confirm": "Confirm",
    "brand.selected": "Selected",
    "brand.clickToSelect": "Select",
    "brand.confirmUse": "Use",
    "brand.confirmNone": "Continue without brand assets",
    "lightbox.label": "Image preview",
    "lightbox.close": "Close preview",
    "lightbox.previous": "Previous image",
    "lightbox.next": "Next image",
    "promptPopover.title": "Prompt Comparison",
    "promptPopover.summary": "Original {original} · optimized {optimized}",
    "promptPopover.original": "Original prompt",
    "promptPopover.optimized": "Optimized prompt",
    "promptPopover.charCount": "{count} chars",
    "promptPopover.empty": "None",
    "promptPopover.notReturned": "Not returned",
    "promptPopover.noOptimized": "No optimized prompt returned",
    "promptPopover.submitted": "View submitted prompt",
    "promptPopover.close": "Close prompt comparison",
    "promptPopover.copyOptimized": "Copy optimized prompt",
    "promptPopover.copied": "Copied",
    "taskContext.menuLabel": "Task context menu",
    "taskContext.more": "More actions",
    "taskContext.view": "View task",
    "taskContext.copyId": "Copy task ID",
    "taskContext.copyPrompt": "Copy prompt",
    "taskContext.revealOutput": "Open output folder",
    "taskContext.archive": "Archive task",
    "taskContext.delete": "Delete task",
    "taskContext.idCopied": "Task ID copied",
    "taskContext.promptCopied": "Prompt copied",
    "taskContext.noPrompt": "This task has no prompt to copy",
    "taskContext.revealFailed": "Failed to open output folder",
    "taskContext.revealOpened": "Output folder opened",
    "taskContext.actionFailed": "Task action failed",
    "taskActions.group": "Task actions",
    "taskActions.deleteTitle": "Delete task?",
    "taskActions.deleteMessage": "This will also delete local image files.",
    "taskActions.runningCannotDelete": "Running tasks cannot be deleted",
    "taskActions.updated": "Task status updated",
    "taskActions.archived": "Chat archived",
    "taskActions.archiveFailed": "Archive failed",
    "taskActions.deleted": "Task deleted",
    "taskActions.deleteFailed": "Delete failed",
    "taskActions.noRetryableFailedImages": "This task has no failed images to retry",
    "taskActions.retryFailedOutputsFailed": "Failed to retry failed images",
    "taskActions.requeuedFailedImages": "Failed images requeued",
    "taskActions.noAcceptableSuccessImages": "This task has no successful images to accept",
    "taskActions.acceptSuccessesFailed": "Failed to accept successful results",
    "taskActions.acceptedSuccesses": "Successful results accepted",
    "taskActions.viewedUpdateFailed": "Failed to update read state",
    "taskActions.failedFallback": "Task failed",
    "taskList.empty": "No history yet",
    "taskList.selectSession": "Select chat",
    "taskList.unreadUpdate": "Unread update",
    "taskList.viewing": "Viewing",
    "taskDerived.usageLimited": "Usage limited",
    "taskSubmit.requestFailed": "Request failed",
    "taskSubmit.queued": "Task added to queue",
    "taskSubmit.timeout": "Submitting the task timed out before the backend responded. Refresh the queue to confirm whether it was added, then decide whether to retry.",
    "taskSubmit.failed": "Task submission failed",
    "templates.title": "Prompt Templates",
    "templates.summary": "Local template library",
    "templates.availableCount": "{count} available templates",
    "templates.noMatch": "No matching templates",
    "templates.empty": "No templates",
    "templates.favoriteBadge": "Favorite",
    "templates.usageCount": "{count} uses",
    "templates.back": "Back",
    "templates.edit": "Edit",
    "templates.copy": "Copy",
    "templates.insert": "Insert",
    "templates.formTitle": "Title",
    "templates.formShortTitle": "Short title",
    "templates.formCategory": "Category",
    "templates.formTags": "Tags",
    "templates.formThumbnail": "Thumbnail",
    "templates.formContent": "Content",
    "templates.formNotes": "Notes",
    "templates.formFavorite": "Favorite",
    "templates.thumbnailClear": "Clear",
    "templates.thumbnailNone": "None selected",
    "templates.thumbnailEmpty": "No history thumbnails",
    "templates.newCategory": "New category",
    "templates.search": "Search templates, tags, or content",
    "templates.filter": "Template filters",
    "templates.all": "All",
    "templates.categoryCommon": "Common",
    "templates.categoryPortrait": "Portrait",
    "templates.categoryProduct": "Product",
    "templates.categoryRepair": "Repair",
    "templates.categoryPoster": "Poster",
    "templates.categoryEcommerce": "E-commerce",
    "templates.favorite": "Favorites",
    "templates.recent": "Recent",
    "templates.category": "Categories",
    "templates.loadFailed": "Failed to load prompt templates",
    "templates.useStateUpdateFailed": "Failed to update prompt template usage state",
    "templates.copied": "Prompt template copied",
    "templates.copyFailed": "Failed to copy prompt template",
    "templates.history": "History",
    "templates.saveFailed": "Failed to save prompt template",
    "templates.saved": "Prompt template saved",
    "templates.deleteFailed": "Failed to delete prompt template",
    "templates.deleted": "Prompt template deleted",
    "templates.categoryAddFailed": "Failed to add template category",
    "templates.categoryAdded": "Template category added",
    "templates.categorySaveFailed": "Failed to save template category",
    "templates.categorySaved": "Template category saved",
    "templates.categoryDeleteFailed": "Failed to delete template category",
    "templates.categoryDeleted": "Template category deleted",
    "templates.importFailed": "Failed to import template pack",
    "templates.importedCount": "Imported {count} templates",
    "templates.exportFailed": "Failed to export template pack",
    "templates.exported": "Template pack exported",
    "snippets.suggestLabel": "Prompt snippet picker",
    "snippets.saveSelection": "Save",
    "snippets.saveSelectionLabel": "Save selected text as a prompt snippet",
    "snippets.popoverLabel": "Prompt snippet",
    "snippets.defaultCategory": "Common",
    "snippets.loadFailed": "Failed to load prompt snippets",
    "snippets.remove": "Remove ~{tag}",
    "snippets.expand": "Expand",
    "snippets.edit": "Edit",
    "snippets.close": "Close",
    "snippets.editTitle": "Edit snippet",
    "snippets.saveTitle": "Save snippet",
    "snippets.shortTag": "Short tag",
    "snippets.title": "Title",
    "snippets.category": "Category",
    "snippets.content": "Content",
    "snippets.titlePlaceholder": "Uses short tag by default",
    "snippets.cancel": "Cancel",
    "snippets.save": "Save",
    "snippets.saveFailed": "Failed to save prompt snippet",
    "snippets.saved": "Prompt snippet saved",
    "snippets.defaultTag": "Common snippet",
    "colors.white": "White",
    "colors.black": "Black",
    "colors.warmBeige": "Warm beige",
    "colors.lightGreen": "Light green",
    "colors.brandGreen": "Brand green",
    "colors.peachOrange": "Peach orange",
    "colors.lightBlue": "Light blue",
    "colors.lightPink": "Light pink",
    "colors.loadFailed": "Failed to load color settings",
    "colors.saveFailed": "Failed to save color settings",
    "colors.importFailed": "Failed to import color settings",
    "colors.importedCount": "Imported {count} colors",
    "colors.recentSaveFailed": "Failed to save recent colors",
    "colors.favoriteSaveFailed": "Failed to save favorite color",
    "colors.favoriteDeleteFailed": "Failed to delete favorite color",
    "colors.update": "Update",
    "colors.insert": "Insert",
    "colors.pick": "Choose color",
    "colors.pickShort": "Pick",
    "colors.hexValue": "Color value",
    "colors.pendingUpdate": "Color changed. Click Update to apply.",
    "colors.save": "Save",
    "colors.exportPs": "Export",
    "colors.importPs": "Import",
    "colors.done": "Done",
    "colors.manage": "Manage",
    "colors.favorites": "Favorite colors",
    "colors.recent": "Recent colors",
    "colors.recentLabel": "Recent",
    "colors.deleteFavorite": "Delete favorite color {name}",
    "colors.modify": "Edit color",
    "colors.modifyValue": "Edit color {value}",
    "colors.removeValue": "Remove color {value}",
    "taskGroup.today": "Today",
    "taskGroup.yesterday": "Yesterday",
    "taskGroup.last7": "Last 7 days",
    "taskGroup.older": "Older",
    "taskGroup.searchResults": "Search results",
    "taskGroup.active": "Active",
    "taskGroup.running": "Running",
    "taskGroup.waiting": "Waiting",
    "taskGroup.dispatchPending": "Assigning an available channel...",
    "taskGroup.expand": "Expand {label}",
    "taskGroup.collapse": "Collapse {label}",
    "taskGroup.buttonLabel": "{label}, {count} tasks",
    "archive.title": "Archive",
    "archive.empty": "No archived chats",
    "archive.count": "{count} archived chats",
    "archive.restore": "Restore",
    "archive.archiveFailed": "Archive failed",
    "archive.restoreFailed": "Restore failed",
    "archive.restored": "Chat restored",
    "archive.archiving": "Archiving...",
    "archive.restoring": "Restoring...",
    "archive.deleting": "Deleting...",
    "archive.restoredCount": "Restored {count} tasks",
    "settings.title": "Storage",
    "settings.status": "Restart WebUI after saving storage paths",
    "settings.inputRoot": "Input folder",
    "settings.outputRoot": "Output folder",
    "settings.galleryRoot": "Gallery folder",
    "settings.sourceDataRoot": "Source data folder",
    "settings.language": "Interface language",
    "settings.languageCopy": "On first launch, the interface follows your browser language. Manual choices are remembered.",
    "settings.notificationsCopy": "Notify when tasks complete or fail. System notifications must be enabled manually.",
    "settings.inAppNotification": "In-app notifications",
    "settings.systemNotification": "System notifications",
    "settings.save": "Save settings",
    "settings.loadFailed": "Failed to load settings",
    "settings.saveFailed": "Failed to save settings",
    "settings.savedRestart": "Storage settings saved. Restart WebUI to apply.",
    "settings.saved": "Saved",
    "settings.savedRestartStatus": "Storage settings saved. Restart WebUI to apply.",
    "systemSettings.title": "System Settings",
    "systemSettings.tabsLabel": "System settings sections",
    "systemSettings.apiTab": "API Settings",
    "systemSettings.codexTab": "Codex Channel",
    "systemSettings.languageTab": "Language",
    "systemSettings.storageTab": "Storage & Notifications",
    "languageSettings.instantStatus": "Language changes apply immediately",
    "apiSettings.title": "API Settings",
    "apiSettings.status": "Saved settings apply immediately in API mode",
    "apiSettings.codexMode": "Codex channel",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API providers",
    "apiSettings.searchProviders": "Search provider names",
    "apiSettings.noProviderSearchResults": "No matching providers",
    "apiSettings.providerCount": "{count} providers",
    "apiSettings.provider": "Provider",
    "apiSettings.providerName": "Provider name",
    "apiSettings.actualRequest": "Actual request",
    "apiSettings.newProviderAction": "New provider",
    "apiSettings.copyProvider": "Copy",
    "apiSettings.copyProviderName": "{name} Copy",
    "apiSettings.copyProviderStatus": "Provider copied with its saved key. Edit the name, model, or replace the key before saving.",
    "apiSettings.copyProviderWithoutKeyStatus": "Provider copied. Edit the name, model, or add an API key before saving.",
    "apiSettings.sortProviders": "Sort",
    "apiSettings.finishSortProviders": "Done",
    "apiSettings.sortProviderModeStatus": "Sorting providers",
    "apiSettings.sortProviderStatus": "Provider order changed. Autosaving...",
    "apiSettings.moveProviderUp": "Up",
    "apiSettings.moveProviderDown": "Down",
    "apiSettings.moveProviderUpAria": "Move {provider} up",
    "apiSettings.moveProviderDownAria": "Move {provider} down",
    "apiSettings.mode": "Request mode",
    "apiSettings.images": "Direct Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Direct",
    "apiSettings.imageModel": "Image generation model",
    "apiSettings.concurrency": "Concurrency limit",
    "apiSettings.concurrencyShort": "Concurrency",
    "apiSettings.advancedSettings": "Advanced settings",
    "apiSettings.concurrencyValue": "concurrency {concurrency}",
    "apiSettings.keySaved": "API key saved",
    "apiSettings.keyNotSet": "API key not set",
    "apiSettings.showApiKey": "Show API key",
    "apiSettings.hideApiKey": "Hide API key",
    "apiSettings.editProvider": "Edit provider",
    "apiSettings.newProviderTitle": "New provider",
    "apiSettings.editHint": "Save provider writes this edit to the backend. Cancel discards it.",
    "apiSettings.finishEditFirst": "Save or cancel the current provider edit first",
    "apiSettings.newDraftStatus": "Creating provider. Save provider to apply.",
    "apiSettings.editDraftStatus": "Editing provider. Save provider to apply.",
    "apiSettings.cancelEdit": "Cancel edit",
    "apiSettings.saveProvider": "Save provider",
    "apiSettings.saveSelection": "Save selection",
    "apiSettings.deleteProviderTitle": "Delete provider?",
    "apiSettings.deleteProviderMessage": "Delete \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "This removes it from the provider list and autosaves it to the backend.",
    "apiSettings.deleteProviderStatus": "Provider deleted. Autosaving...",
    "apiSettings.save": "Save API settings",
    "apiSettings.loadFailed": "Failed to load API settings",
    "apiSettings.savedKeyPlaceholder": "API key is saved on the backend. Enter a new key to replace it.",
    "apiSettings.newProvider": "New provider",
    "apiSettings.saving": "Saving...",
    "apiSettings.savingStatus": "Saving API settings...",
    "apiSettings.autoSaving": "Autosaving...",
    "apiSettings.autoSaved": "Autosaved",
    "apiSettings.saveFailed": "Failed to save API settings",
    "apiSettings.savedSummary": "Saved · Codex {codex} · API {provider} · {mode} · {model} · concurrency {concurrency}",
    "apiSettings.savedShort": "Saved",
    "apiSettings.savedStatus": "API settings saved",
    "apiSettings.saveFailedShort": "Save failed",
    "codexSettings.title": "Codex Channel",
    "codexSettings.status": "Choose the generation channel for the local Codex sign-in",
    "codexSettings.notesLabel": "Codex channel notes",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "Default channel for normal generation and edits, with size, quality, and edit parameters passed directly.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Compatibility channel for tasks that need web search or the Responses tool chain.",
    "codexSettings.current": "Current",
    "codexSettings.save": "Save Codex channel",
    "codexSettings.saveMode": "Save {mode}",
    "imageEditor.title": "Edit Input Image",
    "imageEditor.promptHint": "Hand-drawn arrows and marks in the image are only instructions. Do not keep them in the final image.",
    "imageEditor.inputFallback": "Input image",
    "imageEditor.openFailed": "Failed to open this image for editing",
    "imageEditor.loadForEditFailed": "Failed to load this image for editing",
    "imageEditor.canvasCreateFailed": "Failed to create the image editing canvas",
    "imageEditor.closedRegionRequired": "Use the brush to draw a closed region first",
    "imageEditor.saveFailed": "Failed to save image edit",
    "imageEditor.saved": "Edited input image saved",
    "imageEditor.uneditable": "This image cannot be edited",
    "imageEditor.resetDone": "Reset to original image",
    "imageEditor.resetFailed": "Failed to reset the original image",
    "imageEditor.subtitle": "Crop, draw, fill, or add arrows, then save as a new input image",
    "imageEditor.toolbar": "Image editor toolbar",
    "imageEditor.tools": "Tools",
    "imageEditor.select": "Select",
    "imageEditor.brush": "Brush",
    "imageEditor.arrow": "Arrow",
    "imageEditor.crop": "Crop",
    "imageEditor.fill": "Fill",
    "imageEditor.fillLabel": "Paint bucket fill",
    "imageEditor.eraser": "Eraser",
    "imageEditor.colors": "Colors",
    "imageEditor.red": "Red",
    "imageEditor.blue": "Blue",
    "imageEditor.green": "Green",
    "imageEditor.yellow": "Yellow",
    "imageEditor.white": "White",
    "imageEditor.black": "Black",
    "imageEditor.customColor": "Custom color",
    "imageEditor.stroke": "Stroke",
    "imageEditor.history": "History",
    "imageEditor.undo": "Undo",
    "imageEditor.redo": "Redo",
    "imageEditor.reset": "Reset image",
    "imageEditor.canvas": "Image editing canvas",
    "imageEditor.canvasScope": "Canvas range",
    "imageEditor.canvasScopeBase": "Base image",
    "imageEditor.canvasScopeFit": "Fit layers",
    "imageEditor.canvasFitDone": "Canvas now fits the layers",
    "imageEditor.canvasBaseDone": "Canvas restored to the base image",
    "imageEditor.insertImages": "Insert images",
    "imageEditor.layers": "Layers",
    "imageEditor.layerUp": "Move up",
    "imageEditor.layerDown": "Move down",
    "imageEditor.emptyInsertList": "No other input images",
    "imageEditor.selectLayerFirst": "Select a layer first",
    "imageEditor.baseLayer": "Base image",
    "gallery.title": "Asset Library",
    "gallery.tabReferenceImages": "Reference Images",
    "gallery.subtitle": "Choose reference images for the current task",
    "gallery.manageCategories": "Manage categories",
    "gallery.categoryManager": "Manage gallery categories",
    "gallery.categoryManagement": "Category management",
    "gallery.categoryCopy": "Categories are saved to the gallery; prompt roles describe how references are used.",
    "gallery.newCategoryName": "New category name",
    "gallery.newCategoryRole": "Prompt role, e.g. style reference",
    "gallery.addCategory": "Add category",
    "gallery.drawerSubtitle": "Current category: {category}. Click \"Use\" to add it to image input.",
    "gallery.emptyCategory": "No images in this category yet",
    "gallery.dragSort": "Drag to sort",
    "gallery.dragSortImage": "Drag-sort image {name}",
    "gallery.dragSortCategory": "Drag-sort category {name}",
    "gallery.use": "Use",
    "gallery.replace": "Replace",
    "gallery.rename": "Rename",
    "gallery.moveCategory": "Category",
    "gallery.note": "Note",
    "gallery.delete": "Delete",
    "gallery.uncategorized": "Uncategorized",
    "addGallery.title": "Add to Gallery",
    "addGallery.copy": "Names are globally unique and can be referenced with @name later",
    "addGallery.name": "Name",
    "addGallery.namePlaceholder": "Example: Mia",
    "addGallery.category": "Category",
    "addGallery.note": "Reference note",
    "addGallery.notePlaceholder": "Example: reference face and hair only, not clothing or background",
    "addGallery.save": "Save to gallery",
    "close.promptTemplates": "Close prompt templates panel",
    "close.archive": "Close archive panel",
    "close.settings": "Close storage settings panel",
    "close.apiSettings": "Close API settings panel",
    "close.systemSettings": "Close system settings panel",
    "close.imageEditor": "Close image editor panel",
    "close.gallery": "Close gallery panel",
    "close.addGallery": "Close add to gallery panel",
    "close.version": "Close version update panel",
    "imageInput.referenceTitle": "Reference input (optional)",
    "imageInput.materialsTitle": "Materials & references (optional)",
    "imageInput.referenceImages": "Reference images",
    "imageInput.referenceImagesHint": "Guide content, composition, or style",
    "referenceFiles.add": "Add file",
    "referenceFiles.selected": "Reference files",
    "referenceFiles.recent": "Recent files",
    "referenceFiles.familyPdf": "Pages + text",
    "referenceFiles.familySpreadsheet": "Spreadsheet",
    "referenceFiles.familyDocument": "Document",
    "referenceFiles.familyText": "Text",
    "referenceFiles.visualLimit": "Embedded images and charts are not preserved in non-PDF files. Convert to PDF when layout matters.",
    "referenceFiles.remove": "Remove {filename}",
    "referenceFiles.switchTitle": "Remove reference files?",
    "referenceFiles.switchMessage": "Reference files work only with Responses. Remove the selected files before switching to Images.",
    "referenceFiles.removeAndSwitch": "Remove files and switch",
    "referenceFiles.requiresResponses": "Reference files require Responses",
    "referenceFiles.switchToResponses": "Switch to Responses",
    "referenceFiles.openApiSettings": "Open API settings",
    "referenceFiles.providerMissing": "The original Responses provider is unavailable. Choose one in API settings.",
    "referenceFiles.missing": "File missing",
    "referenceFiles.loadFailed": "Failed to load reference files",
    "referenceFiles.errorEmpty": "The reference file is empty",
    "referenceFiles.errorUnsupported": "This reference file type is unsupported",
    "referenceFiles.errorMismatch": "The file type does not match its extension",
    "referenceFiles.errorInvalid": "The reference file is invalid",
    "referenceFiles.errorTooLarge": "Each reference file must be smaller than 50 MB",
    "referenceFiles.errorTotalTooLarge": "Reference files may total at most 50 MB",
    "referenceFiles.errorMissing": "A selected reference file is missing",
    "referenceFiles.errorProviderUnsupported": "This provider does not support reference files in Responses",
    "referenceFiles.responsesEnabled": "Responses enabled",
    "referenceFiles.historyPathMismatch": "These reference files use different Responses paths",
    "history.referenceFiles": "Reference files",
    "history.downloadReferenceFile": "Download file",
    "history.readdReferenceFile": "Add again"
};
